<template>
  <Modal v-model="modalSupplierConfig" :mask-closable="false" width="1000">
    <p slot="header">
        <span class="text-14">供应商快捷配置</span>
        <span class="remark">（配置将生效供应商相关所有成本项）</span>
    </p>

    <Card v-for="(item,index) in suppilerConfigs" :key="index" :bordered="false" class="m-t-5 m-b-10" >
      <Row>
        <i-col span="8" class="text-14">
          {{item.companyName}}
        </i-col>
        <i-col span="16">
          公司是否生效
          <i-switch v-model="item.enabled" class="m-l-5">
            <Icon type="md-checkmark" slot="open"></Icon>
            <Icon type="md-close" slot="close"></Icon>
          </i-switch>
        </i-col>
      </Row>
      <Row class="m-t-10">
        <i-col span="24">
          <span class="text-red">* </span>运维资产
          <Checkbox
            class="m-l-5"
            :disabled="!item.enabled"
            :indeterminate="item.indeterminateAsset"
            :value="item.checkAllAsset"
            @click.prevent.native="handleCheckAllAsset(item)">全选</Checkbox>
        </i-col>
      </Row>
      <Divider dashed style="margin: 5px 0;"/>
      <Row>
        <i-col span="24">
          <CheckboxGroup v-model="item.assetIdList" @on-change="handleChangeAssets(item)">
            <Checkbox v-for="asset in assetArray" :key="asset.id" :disabled="!item.enabled" :label="asset.id">{{asset.name}}</Checkbox>
          </CheckboxGroup>
          <p v-if="item.showErrorMsg" class="m-t-5 text-red">* 生效的供应商必须选择对应资产线路！</p>
        </i-col>
      </Row>

    </Card>

    <div slot="footer">
      <Button type="text" @click="modalSupplierConfig = false">取消</Button>
      <Button type="primary" @click="handleSubmit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { getCompanyList } from '@/api/os/company'
import { getPublisherAssetList } from '@/api/rim/asset'
import { getCompanyAssetIdList, saveOrUpdateCompanyAssets } from '@/api/msp/serviceversion'

export default {
  data () {
    return {
      modalSupplierConfig: false,

      maintenanceCompanyList: [], // 运维公司清单
      assetArray: [], // 媒介组资产清单
      suppilerConfigs: [], // 配置集合

      saveBean: {
        detailDtoList: [
          {
            assetIdList: [],
            companyId: 0,
            enabled: true
          }
        ],
        serviceVersionId: 0
      }
    }
  },
  mounted () {
    this.initBaseData()
  },
  methods: {
    initBaseData () {
      // 获取供应商清单
      const postData2 = {
        publisherId: this.$store.getters.token.userInfo.publisherId,
        enabled: true,
        type: 3
      }
      getCompanyList(postData2).then(res => {
        this.maintenanceCompanyList = res
      })
      // 获取全部运维线路
      this.getAssetData()
    },
    async getAssetData () {
      const result = await getPublisherAssetList() || []
      this.assetArray = [...result]
    },
    showModal () {
      this.modalSupplierConfig = true
      this.saveBean.serviceVersionId = this.detailBean.serviceVersionId
      this.loadSuppilerConfigData()
    },
    loadSuppilerConfigData () {
      getCompanyAssetIdList({ serviceVersionId: this.detailBean.serviceVersionId }).then(res => {
        if (res.length > 0) {
          this.formatSupilerConfig(res)
        } else {
          this.initSuppilerConfig()
        }
      })
    },
    initSuppilerConfig () {
      const tempDetailDtoList = []

      this.maintenanceCompanyList.forEach(item => {
        tempDetailDtoList.push({
          assetIdList: [],
          companyId: item.id,
          enabled: true,
          companyName: item.name,
          indeterminateAsset: false,
          checkAllAsset: false,
          showErrorMsg: false
        })
      })

      this.suppilerConfigs = tempDetailDtoList
    },
    formatSupilerConfig (configData) {
      const tempDetailDtoList = []
      let configItem = null
      let currentItem = null // 当前需要添加的项

      this.maintenanceCompanyList.forEach(item => {
        configItem = configData.find(x => x.companyId === item.id)
        if (configItem) {
          currentItem = {
            assetIdList: configItem.assetIdList,
            companyId: item.id,
            enabled: configItem.enabled,
            companyName: item.name,
            indeterminateAsset: false,
            checkAllAsset: false,
            showErrorMsg: false
          }

          if (currentItem.assetIdList.length === this.assetArray.length) {
            currentItem.indeterminateAsset = false
            currentItem.checkAllAsset = true
          } else if (currentItem.assetIdList.length > 0) {
            currentItem.indeterminateAsset = true
            currentItem.checkAllAsset = false
          } else {
            currentItem.indeterminateAsset = false
            currentItem.checkAllAsset = false
          }

          tempDetailDtoList.push(currentItem)
        } else { // 如果当前供应商从未设置过
          tempDetailDtoList.push({
            assetIdList: [],
            companyId: item.id,
            enabled: false,
            companyName: item.name,
            indeterminateAsset: false,
            checkAllAsset: false,
            showErrorMsg: false
          })
        }
      })

      this.suppilerConfigs = tempDetailDtoList
    },
    handleSubmit () {
      const tempDetailDtoList = []
      let allowSubmit = true
      this.suppilerConfigs.forEach(element => {
        if (element.enabled && element.assetIdList.length === 0) {
          element.showErrorMsg = true
          allowSubmit = false
        }

        tempDetailDtoList.push({
          assetIdList: element.assetIdList,
          companyId: element.companyId,
          enabled: element.enabled
        })
      })

      // 如果未选中数据， 那么返回
      if (allowSubmit) {
        this.saveBean.detailDtoList = tempDetailDtoList
        saveOrUpdateCompanyAssets(this.saveBean).then(res => {
          if (res.success) {
            this.$Notice.success({ desc: '供应商信息配置成功！' })
            // 防止供应商被禁用， 导致的数据异常
            this.$emit('on-suplier-config-success')
            this.modalSupplierConfig = false
          }
        })
      }
    },
    handleCheckAllAsset (item) {
      if (item.indeterminateAsset) {
        item.checkAllAsset = false
      } else {
        item.checkAllAsset = !item.checkAllAsset
      }
      item.indeterminateAsset = false

      if (item.checkAllAsset) {
        item.assetIdList = this.assetArray.map(x => x.id)
      } else {
        item.assetIdList = []
      }
    },
    handleChangeAssets (item) {
      if (item.assetIdList.length === this.assetArray.length) {
        item.indeterminateAsset = false
        item.checkAllAsset = true
      } else if (item.assetIdList.length > 0) {
        item.indeterminateAsset = true
        item.checkAllAsset = false
      } else {
        item.indeterminateAsset = false
        item.checkAllAsset = false
      }
    }
  },
  computed: {
    detailBean () { // 成本详情
      return this.$store.state.serviceConfig.detailBean
    }
  }
}
</script>
